import { format, utcToZonedTime } from 'date-fns-tz';

export const formatUTCDate = (date: Date | string, formatString: string): string => {
  return format(utcToZonedTime(date, 'UTC'), formatString, { timeZone: 'UTC' });
};

export const formatLocalDateTime = (date: Date | string, formatString: string, timeZone?: string): string => {
  // Get the local timezone from the browser
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const tz = timeZone ?? localTimeZone;
  return format(utcToZonedTime(date, tz), formatString, { timeZone: tz });
};
